module.exports = __webpack_public_path__ + "bf.svg?348494c4020e910a1c5ebf26ad17c27b";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/bf.svg
// module id = 1251
// module chunks = 0